// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_centered-col__\\+8AtK {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center; }

.styles_hide-scrollbar__0NSnm {
  -ms-overflow-style: none;
  scrollbar-width: none; }
  .styles_hide-scrollbar__0NSnm::-webkit-scrollbar {
    display: none; }

.styles_singleLineText__ZysXe {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis; }

.styles_width-fill-available__q4\\+zl, button.styles_btn__orck- {
  width: 100%;
  /* WebKit-based browsers will ignore this. */
  width: -webkit-fill-available;
  /* Mozilla-based browsers will ignore this. */
  width: fill-available; }

.styles_height-fill-available__zTOaB {
  height: 100%;
  /* WebKit-based browsers will ignore this. */
  height: -webkit-fill-available;
  /* Mozilla-based browsers will ignore this. */
  height: fill-available; }

button.styles_btn__orck- {
  border: 1px solid #8080805c;
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 1rem;
  border-radius: 1rem;
  min-height: 5rem;
  margin: 1rem; }
  button.styles_btn__orck- p {
    font-size: 1rem; }
  button.styles_btn__orck-.styles_disabled__JxgRK > span:nth-child(2) {
    display: none; }
  button.styles_btn__orck- .styles_noChevron__Afo7J {
    display: none; }

button.styles_guideButton__lfCsM {
  position: absolute;
  top: 0.25rem;
  right: 1.5rem;
  background: #fff;
  padding: 1rem;
  min-width: 2rem;
  min-height: 2rem; }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/styles/classes.scss","webpack://./src/modules/Core/sub-modules/ui-kit/components/PanelButton/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,wBAAwB;EACxB,qBAAqB,EAAA;EAFvB;IAII,aAAa,EAAA;;AAIjB;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB,EAAA;;AAGzB;EACE,WAAW;EACY,4CAAA;EACvB,6BAA6B;EAAE,6CAAA;EAC/B,qBAAqB,EAAA;;AAGvB;EACE,YAAY;EACY,4CAAA;EACxB,8BAA8B;EAAE,6CAAA;EAChC,sBAAsB,EAAA;;AC7BxB;EAEE,2BCSgB;EDRhB,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY,EAAA;EARd;IAUI,eAAe,EAAA;EAVnB;IAaI,aAAa,EAAA;EAbjB;IAgBI,aAAa,EAAA;;AAIjB;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB,EAAA","sourcesContent":[".centered-col {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.hide-scrollbar {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n  &::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.singleLineText {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.width-fill-available {\n  width: 100%;\n  width: -moz-available; /* WebKit-based browsers will ignore this. */\n  width: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */\n  width: fill-available;\n}\n\n.height-fill-available {\n  height: 100%;\n  height: -moz-available; /* WebKit-based browsers will ignore this. */\n  height: -webkit-fill-available; /* Mozilla-based browsers will ignore this. */\n  height: fill-available;\n}\n","@import \"src/modules/Core/styles/variables.scss\";\n@import \"src/modules/Core/styles/classes.scss\";\n\nbutton.btn {\n  @extend .width-fill-available;\n  border: 1px solid $grey36;\n  display: flex;\n  justify-content: space-between;\n  padding: 0.5rem 1rem;\n  border-radius: 1rem;\n  min-height: 5rem;\n  margin: 1rem;\n  & p {\n    font-size: 1rem;\n  }\n  &.disabled > span:nth-child(2) {\n    display: none;\n  }\n  & .noChevron {\n    display: none;\n  }\n}\n\nbutton.guideButton {\n  position: absolute;\n  top: 0.25rem;\n  right: 1.5rem;\n  background: #fff;\n  padding: 1rem;\n  min-width: 2rem;\n  min-height: 2rem;\n}\n","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"centered-col": `styles_centered-col__+8AtK`,
	"hide-scrollbar": `styles_hide-scrollbar__0NSnm`,
	"singleLineText": `styles_singleLineText__ZysXe`,
	"width-fill-available": `styles_width-fill-available__q4+zl`,
	"btn": `styles_btn__orck-`,
	"height-fill-available": `styles_height-fill-available__zTOaB`,
	"disabled": `styles_disabled__JxgRK`,
	"noChevron": `styles_noChevron__Afo7J`,
	"guideButton": `styles_guideButton__lfCsM`
};
export default ___CSS_LOADER_EXPORT___;
